
export default function PartnersSection() {
  const partners = [
    {
      name: "LoyalLocals",
      description: "Powering loyalty, engagement, and education for healthcare communities across Canada.",
      logo: "https://public.readdy.ai/ai/img_res/a09a4961491b6a5433c68a5be0be655e.jpg",
      featured: true
    },
    {
      name: "HealthTech Solutions",
      description: "Advanced technology solutions for modern healthcare practices.",
      logo: "https://readdy.ai/api/search-image?query=Healthcare%20technology%20company%20logo%2C%20modern%20medical%20tech%20branding%2C%20clean%20professional%20design%2C%20digital%20health%20logo%2C%20innovative%20healthcare%20solutions%20branding&width=200&height=100&seq=health1&orientation=landscape"
    },
    {
      name: "MedEd Institute",
      description: "Leading provider of continuing education for healthcare professionals.",
      logo: "https://readdy.ai/api/search-image?query=Medical%20education%20institute%20logo%2C%20professional%20academic%20branding%2C%20healthcare%20education%20logo%2C%20clean%20educational%20institution%20design%2C%20medical%20training%20company%20logo&width=200&height=100&seq=meded1&orientation=landscape"
    },
    {
      name: "VetCare Network",
      description: "Comprehensive veterinary care solutions and professional support.",
      logo: "https://readdy.ai/api/search-image?query=Veterinary%20care%20network%20logo%2C%20professional%20animal%20healthcare%20branding%2C%20clean%20vet%20clinic%20logo%2C%20modern%20veterinary%20services%20design%2C%20animal%20health%20company%20logo&width=200&height=100&seq=vet1&orientation=landscape"
    }
  ];

  return (
    <section className="py-16 bg-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Our Partners
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Collaborating with leading organizations to advance healthcare excellence and innovation.
          </p>
        </div>
        
        {/* Featured Partner */}
        <div className="bg-white rounded-xl shadow-lg p-8 mb-12">
          <div className="flex flex-col lg:flex-row items-center gap-8">
            <div className="lg:w-1/3">
              <img
                src={partners[0].logo}
                alt={partners[0].name}
                className="w-full h-24 object-contain"
              />
            </div>
            <div className="lg:w-2/3 text-center lg:text-left">
              <div className="inline-block bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium mb-4">
                Featured Partner
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {partners[0].name}
              </h3>
              <p className="text-gray-600 text-lg">
                {partners[0].description}
              </p>
            </div>
          </div>
        </div>
        
        {/* Other Partners */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {partners.slice(1).map((partner, index) => (
            <div key={index} className="bg-white rounded-lg shadow-md p-6 text-center hover:shadow-lg transition-shadow">
              <img
                src={partner.logo}
                alt={partner.name}
                className="w-full h-16 object-contain mb-4"
              />
              <h4 className="text-lg font-semibold text-gray-900 mb-2">
                {partner.name}
              </h4>
              <p className="text-gray-600 text-sm">
                {partner.description}
              </p>
            </div>
          ))}
        </div>
        
        <div className="text-center mt-12">
          <p className="text-gray-600 mb-6">
            Interested in partnering with CPVA? Let's work together to advance healthcare.
          </p>
          <button className="bg-blue-900 text-white px-8 py-3 rounded-lg font-medium hover:bg-blue-800 cursor-pointer whitespace-nowrap">
            Become a Partner
          </button>
        </div>
      </div>
    </section>
  );
}
